<div [@.disabled]="disableAnimation" class="my-container" [@trigger] *ngIf="show" (@trigger.done)="animationCallback($event)" #signInContainer>

  <div class="right-content">
    <a (click)="close()">
      <i class="material-icons has-pos-abs back-action">close</i>
    </a>
    <div id="login-label-myReMax" class="top-wrapper is-flex">
      <span class="my-remax-title red" translate='registration.re'></span>
      <span class="my-remax-title" translate='registration.slash'></span>
      <span class="my-remax-title red" translate='registration.max'></span>
    </div>

    <app-sign-in #signIn *ngIf="showSignIn" [sourcePage]="loginSource" (continueWithSocialLogin)="continueLogin($event)" (showForgotPassword)="forgotPassword($event)" [email]="email"></app-sign-in>
    <app-forgot-password *ngIf="showForgotPassword" (showForgotPassword)="forgotPassword($event)" [email]="email"></app-forgot-password>
  </div>
  <div class="left-content">
    <app-promotional-overlay [sourcePage]="loginSource"></app-promotional-overlay>
  </div>

</div>
